/** Route patterns for router config */
export const authRoutePatterns = {
  signIn: '/signin',
  signUp: '/signup',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
} as const;

/** Full paths for navigation (navigate, Link) */
export const authRoutes = authRoutePatterns;
